import { useState } from 'react';

import SEO from '../components/SEO/SEO';
import MobileNav from '../components/Navigations/mobileNav';
import Nav from '../components/Navigations/desktopNav';
import Header from '../layout/client-side/installations/product-intro';
import type { Swiper as SwiperType } from 'swiper';
// import Products from '../layout/client-side/installations/products';
import CTA from '../components/CTA/call-to-action';
import Footer from '../components/Footer/footer';
import { Wrench, Instagram } from 'lucide-react';

const Installations = () => {
  const [swiper] = useState<SwiperType | null>(null);

  return (
    <>
      <SEO
        title="AirSolutions Belgium - Uw partner voor airconditioning en koeltechniek"
        description="Ontdek AirSolutions Belgium, uw betrouwbare partner voor airconditioning en koeltechniek. Wij bieden op maat gemaakte oplossingen voor residentiële en commerciële toepassingen."
        keywords="AirSolutions, airconditioning, koeltechniek, HVAC, residentieel, commercieel"
        canonical="/catalogus"
      />
      <MobileNav />
      <Nav swiper={swiper} />
      <Header />
      <section
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '5rem',
          textAlign: 'center',
          padding: '2rem 1rem',
          height: '250px',
          backgroundColor: '#d9a673',
        }}
      >
        {/* Title with maintenance icon */}
        <h2
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <Wrench size={40} />
          Pagina in onderhoud
        </h2>

        <p style={{ marginTop: '0.5rem' }}>
          Deze pagina is momenteel in ontwikkeling. We werken hard aan nieuwe content. Kom
          binnenkort terug!
        </p>

        {/* Social Links with Icons */}
        <div
          style={{
            marginTop: '1.5rem',
            display: 'flex',
            gap: '2rem',
          }}
        >
          <a
            href="https://www.instagram.com/airsolutionsbelgium/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white' }}
          >
            <Instagram size={24} />
          </a>

          {/* <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white' }}
          >
            <Facebook size={24} />
          </a>

          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white' }}
          >
            <Linkedin size={24} />
          </a> */}
        </div>
      </section>
      {/* <Products /> */}
      <CTA />
      <Footer />
    </>
  );
};

export default Installations;
